export default __webpack_public_path__ + "static/media/ham-menu.67af819c.svg";